export default __webpack_public_path__ + "static/media/ic_bar_left_app.137539d2.svg";